// @flow
import * as React from 'react';
import TextField from '@material-ui/core/TextField';
import { Field, getIn } from 'formik';

type Props = {
  component?: React.ElementType,
  disabled?: boolean,
  handleBlur?: any => void,
};

const FormikTextField = ({
  component,
  disabled,
  handleBlur,
  ...fieldProps
}: Props) => (
  <Field {...fieldProps}>
    {({ field, form, ...props }) => {
      const ComponentProp = component || TextField;
      const { name, value } = field;
      const { touched, errors, isSubmitting } = form;

      const fieldError = getIn(errors, name);
      const showError = getIn(touched, name) && !!fieldError;
      return (
        <ComponentProp
          {...fieldProps}
          {...props}
          {...field}
          value={value === undefined ? '' : value}
          error={showError}
          helperText={showError ? fieldError : props.helperText}
          disabled={isSubmitting || disabled}
          onBlur={event => handleBlur && handleBlur(event)}
        />
      );
    }}
  </Field>
);

export default FormikTextField;
